module.exports = __webpack_public_path__ + "static/media/unlock.32affc28.svg";